export enum ApplicationModalStep {
    APPLICATION_FORM_STANDARD,
    NOTIFICATION_CONSENT,
    SUCCESS_INFO,
    GOODBYE_INFO,
    MULTILEAD,
    CLOSE,
    WAITING,
    APPLICATION_FORM_FULL_OFFER,
    APPLICATION_FORM_WITH_NEGOTIATION,
    APPLICATION_FORM_WITH_TOPIC
}
